// src/App.js
import './App.scss';
import './custom.scss';
import { RouterProvider } from 'react-router-dom';
import router from './routers/router';
import { preloadFont } from 'troika-three-text';
import { App as AntApp, ConfigProvider } from 'antd';
import viVN from 'antd/locale/vi_VN';
import { useEffect } from 'react';
import { notification } from 'antd';
import { StyleProvider } from 'antd-style';
import { CountryCodeContext } from './hooks/context/CountryCode.context.js';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDefaultPriceConfig } from './store/actions/default.config.action.js';
import { refreshUser } from './store/actions/auth.action.js';
// import * as Sentry from '@sentry/react';

preloadFont(
  {
    font: '/fonts/Manrope-Medium.ttf',
    characters:
      'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890,.',
  },
  () => {}
);

function App() {
  // Disable console.log trong production
  if (process.env.NODE_ENV === 'production') {
    console.log = () => {};
    console.debug = () => {};
    console.error = () => {};
    console.warn = () => {};
  }

  const dispatch = useDispatch();
  const country_code = process.env.REACT_APP_COUNTRY_CODE ?? 'vn';
  const { user, accessToken } = useSelector(state => state.auth);

  // Làm mới quyền (permissions) của phiên đăng nhập có sẵn trong cookie, vì quyền có thể đã đổi từ lần đăng nhập trước.
  // Lỗi 401 do refreshUser phát ra đã được errorMiddleware xử lý (đăng xuất).
  useEffect(() => {
    if (accessToken && user?.id) {
      dispatch(refreshUser(user.id)).catch(() => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    notification.config({
      top: 16,
      bottom: 16,
      right: 16,
      left: 16,
    });
    localStorage.setItem('country_code', country_code);
    dispatch(fetchDefaultPriceConfig({ country_code: 'vn' })).catch(e => {
      // Sentry.captureException(e);
    });
    dispatch(fetchDefaultPriceConfig({ country_code: 'us' }))
      .then(action => {
        if (action.payload?.data) {
          const { data } = action.payload;
          const ruleConfig = data.rule;
          localStorage.setItem(
            'exchangeRate',
            ruleConfig?.pro?.variables?.exchangeRate
          );
        }
      })
      .catch(e => {
        // Sentry.captureException(e);
      });
  }, []);

  return (
    <StyleProvider>
      <ConfigProvider
        locale={viVN}
        theme={{
          cssVar: true,
          hashed: false,
        }}
        wave={{ disabled: true }}
        getPopupContainer={node => node?.parentElement || document.body}
        notification={{
          getContainer: () => document.body,
          stack: { threshold: 2 },
        }}
        message={{
          getContainer: () => document.body,
        }}
      >
        <AntApp>
          <CountryCodeContext.Provider value={{ country_code }}>
            <RouterProvider router={router} />
          </CountryCodeContext.Provider>
        </AntApp>
      </ConfigProvider>
    </StyleProvider>
  );
}

export default App;
